var _Circle, _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F7931A"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.005 11.21a.739.739 0 0 1 .324-.058c.139 0 .259.055.36.166.1.11.151.237.151.381 0 .26-.106.442-.317.547-.451.25-.933.461-1.447.634s-1.128.26-1.843.26c-.715 0-1.38-.118-1.995-.354a4.512 4.512 0 0 1-1.598-1.03c-.96-.94-1.44-2.202-1.44-3.786s.48-2.847 1.44-3.788C5.57 3.261 6.77 2.8 8.24 2.8c.71 0 1.322.086 1.836.26.514.172.907.333 1.18.482.274.148.44.268.498.36a.636.636 0 0 1 .086.345.54.54 0 0 1-.151.375c-.101.11-.221.165-.36.165a.739.739 0 0 1-.324-.057 6.973 6.973 0 0 0-1.181-.49c-.403-.125-.905-.187-1.505-.187-.6 0-1.142.1-1.627.302-.485.202-.89.48-1.217.835-.643.701-.965 1.628-.965 2.78s.322 2.078.965 2.779c.701.758 1.666 1.137 2.895 1.137.566 0 1.05-.062 1.454-.187a6.965 6.965 0 0 0 1.18-.49Z",
    fill: "white"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.822 9.605a.37.37 0 0 1 .162-.029c.07 0 .13.028.18.083.05.055.076.119.076.19 0 .13-.053.221-.159.274-.225.125-.466.23-.723.317-.257.087-.564.13-.922.13-.357 0-.69-.06-.997-.177a2.257 2.257 0 0 1-.8-.514c-.48-.47-.72-1.102-.72-1.894 0-.792.24-1.423.72-1.894.467-.46 1.067-.69 1.8-.69.356 0 .662.042.919.129.257.086.454.167.59.24.137.075.22.135.249.181a.318.318 0 0 1 .043.173.27.27 0 0 1-.076.187.236.236 0 0 1-.18.083.37.37 0 0 1-.162-.029 3.485 3.485 0 0 0-.59-.245 2.58 2.58 0 0 0-.752-.093c-.3 0-.572.05-.814.15-.242.102-.445.24-.608.418-.322.35-.483.814-.483 1.39s.16 1.04.483 1.39c.35.379.832.568 1.447.568.283 0 .525-.03.727-.093.202-.063.398-.144.59-.245Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
};
export default SvgCoin;